var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"noPadding border-0 bg-transparent",attrs:{"disabled":_vm.disabled},on:{"click":_vm.defaultClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }